import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/software",
          name: "software",
          component: (resolve) => require(["@/view/Software"], resolve),
          meta: {
            title: "软件产品",
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown",
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "软件产品丨智能小镇管理系统",
              },
            },
            {
              path: "/software/bigData",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "软件产品丨大数据管理系统",
              },
            },
          ],
        },
        {
          path: "/service",
          name: "service",
          component: (resolve) => require(["@/view/Service"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: (resolve) => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态",
          },
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: (resolve) =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍",
          },
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: (resolve) => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会",
          },
        },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: (resolve) => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/AboutUs",
          name: "AboutUs",
          component: (resolve) => require(["@/view/AboutUs"], resolve),
          meta: {
            title: "关于彩讯",
          },
        },
        {
          path: "/Overview",
          name: "Overview",
          component: (resolve) => require(["@/view/Overview"], resolve),
          meta: {
            title: "产品概况",
          },
        },
        {
          path: "/Solution",
          name: "Solution",
          component: (resolve) => require(["@/view/Solution"], resolve),
          meta: {
            title: "解决方案",
          },
        },
        {
          path: "/Develop",
          name: "Develop",
          component: (resolve) => require(["@/view/Develop"], resolve),
          meta: {
            title: "开发文档",
          },
        },
        {
          path: "/privacyPolicy",
          name: "privacyPolicy",
          component: (resolve) => require(["@/view/privacyPolicy"], resolve),
          meta: {
            title: "隐私政策",
          },
        },
        {
          path: "/protoSdk",
          name: "protoSdk",
          component: (resolve) => require(["@/view/privacyPolicy"], resolve),
          meta: {
            title: "合规说明",
          },
        },
      ],
    },
  ],
});
// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  // to: Route: 将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。
  //       执行效果依赖 next 方法的调用参数。

  // 你可以在这里添加任何你想在路由跳转前执行的逻辑

  next();
  // 如果有其他条件判断，可以在这里继续添加
  // ...
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js